// Sponsor setup form (Stuart, 29 Oct: "the discounts don't match", "the
// wording cuts off the period the discount is valid for", "a character count
// for each field so the text doesn't get cut off").
//
// The offer is written ONCE: the offer line (offer_title) and the small print
// (offer_description). The short badge members see ("15% off", offer_value)
// is no longer typed — it's made from the till discount, so it can't disagree
// with what staff take off. offerMismatch spots an offer or small print that
// promises a different discount from the till. Pure — tested by
// sponsorOffer.test.mjs (node --test).

// Sized to the places the text is shown whole: the Wallet card, the scan
// screen, the hub's featured bar and the sponsor ads (B-50: the ad's small
// print shows up to 100 characters over three lines).
export const OFFER_MAX = 40;
export const TERMS_MAX = 100;

function num(rate) {
  if (rate === '' || rate == null) return null;
  const n = Number(rate);
  return Number.isFinite(n) && n > 0 ? n : null;
}

function trimNumber(n) {
  return String(Math.round(n * 100) / 100);
}

function pounds(n) {
  return Number.isInteger(n) ? `£${n}` : `£${n.toFixed(2)}`;
}

// "15% off" / "£5 off" / "£2.50 off", or '' with no usable rate.
export function discountLabel(type, rate) {
  const n = num(rate);
  if (n == null) return '';
  return type === 'fixed' ? `${pounds(n)} off` : `${trimNumber(n)}% off`;
}

// Every discount the text promises: "20%", "20 per cent", "£5 off".
// A bare "£10" (a minimum spend, a cap) isn't a discount, so only "£N off".
export function discountsMentioned(text) {
  const found = [];
  const s = String(text || '');
  for (const m of s.matchAll(/(\d+(?:\.\d+)?)\s*(?:%|per\s?cent\b)/gi)) {
    found.push({ type: 'percentage', n: Number(m[1]), label: `${trimNumber(Number(m[1]))}%` });
  }
  for (const m of s.matchAll(/£\s*(\d+(?:\.\d{1,2})?)\s*off\b/gi)) {
    found.push({ type: 'fixed', n: Number(m[1]), label: `${pounds(Number(m[1]))} off` });
  }
  return found;
}

// null when the words agree with the till (or promise no figure at all);
// otherwise { said: '20%', till: '15% off' | null } — till null when no till
// discount has been set yet.
export function offerMismatch({ type, rate, texts }) {
  const mentions = (texts || []).flatMap(discountsMentioned);
  if (!mentions.length) return null;
  const n = num(rate);
  const till = discountLabel(type, rate) || null;
  const wrong = mentions.find(m => n == null
    || m.type !== (type === 'fixed' ? 'fixed' : 'percentage')
    || Math.abs(m.n - n) > 0.001);
  return wrong ? { said: wrong.label, till } : null;
}
